import styled from 'styled-components';

export const Wrapper = styled.div`
	&& .editSensorData-newValue input {
		padding-top: 7.5px;
		padding-bottom: 7.5px;
	}
`;
